import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


function TooltipRating({ ratings, ratingsList, title }) {
    const renderTooltipRating = (props) => (
        <Tooltip className='contentOverviewTooltipRating' id="tooltipRating" {...props}>
            {ratingsList && <React.Fragment>
                <strong className="contentOverviewTooltipRatingTitle">{title}</strong>
                {Object.entries(ratingsList)?.map(([key, value]) =>
                (<div className={`contentOverviewTooltipRatingContainer-${key} contentOverviewTooltipRatingContainer`} id={`tooltipRating-${key}`}>
                    <p className="contentOverviewTooltipRatingKey">{key}</p><div className="contentOverviewTooltipRatingText">{value}</div>
                </div>))}
            </React.Fragment>}
        </Tooltip>
    )

    return (
        <React.Fragment>
            <OverlayTrigger
                key={'renderTooltipRating-right'}
                placement={'right'}
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltipRating}
            >
                <p className="contentOverviewRating" >{ratings?.join(', ')}</p>
            </OverlayTrigger>
        </React.Fragment>
    );
}

export default TooltipRating;
